/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import usePersistentStore from "../../persistentStore";
import {useHistory, useLocation} from "react-router-dom";

const useStyles = makeStyles(theme => ({

}));

const RejectTeamInvitation = (props) => {
    const classes = useStyles();
    const [globalPersistentState] = usePersistentStore();
    const history = useHistory();
    let location = useLocation();

    useEffect(() => {
        if (!globalPersistentState.me) {
            if (window.location.pathname.indexOf('/sign-') === -1) localStorage.setItem('redirectPage', JSON.stringify(location.pathname));
            console.log('## SVR rejectTeamInvitation ## changing history', '/sign-in');
            history.push('/sign-in');
        }
    },[]);

    return (
        <Container>
            <Grid container>
                <Grid item xs={12} className={classes.gridItem}>
                    <Typography>
                        You have rejected the team
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    )
};

export default RejectTeamInvitation;
